package xyz.malefic.home.util

enum class ModuleSize {
    SMALL,
    MEDIUM,
    LARGE,
}
